export default {
    title: 'Les essentiels',
    subTitle: 'L’activité économique vue par Alan Mudie, responsable de la stratégie d’investissement de Société Générale Private Banking.',
    keyFigures: [
          {
            title: 'États-Unis',
            content: 'Début septembre 2018, la capitalisation boursière de deux sociétés américaines – Apple et, ensuite, Amazon – a dépassé la barre symbolique des 1 trillion de dollars, pour la première fois de l’Histoire. La valeur des deux entreprises dépasserait ainsi la taille de l’économie italienne (1,9 trillion de dollars à fin 2017, selon le Fonds monétaire international).',
        },
         {
            title: 'Suisse',
            figure: 1,
            suffix: 'er',
            icon: 'trophy',
            content: '<p>Selon Deloitte*, la Suisse reste le premier centre de gestion de fortune au monde pour les actifs internationaux avec <span class="renvoi" data-tippy-content="Deloitte Touche Tohmatsu Ltd. est l’un des quatre principaux cabinets d’audit et conseil mondiaux.">1 840 milliards de dollars US à la fin 2017</span>. Les États-Unis et la Grande-Bretagne complètent le podium.</p>',
        },

        {
            title: 'Royaume-Uni',
            prefix: '£ ',
            figure: 92,
            unit: 'milliards',
            icon: 'chart-line',
            content: 'C’est la valeur ajoutée générée en 2016 par les industries de la création – publicité, audiovisuel, jeux vidéo, etc. En progression de 7,6 % sur un an, ces industries affichent un taux de croissance plus de deux fois plus rapide que le reste de l’économie et représentent plus de 5 % de la création de richesse dans le Royaume-Uni.',
        },

        {
            title: 'Chine',
            figure: 16807,
            suffix: ' $',
            icon: 'chart-line',
            content: 'Mesuré en parité de pouvoir d’achat – pour gommer la volatilité des devises – le produit intérieur brut (PPA) par habitant en Chine atteignait 16 807 dollars fin 2017, selon la Banque mondiale, contre 2 071 dollars vingt ans auparavant. Toujours en termes de PPA, la Chine a dépassé les États-Unis en 2013 déjà pour devenir la première puissance économique du monde.',
        },
       {
            title: 'Japon',
            content: 'Selon le World Factbook de la CIA, le Japon affiche l’âge médian le plus élevé au monde à 47,3 ans. Face à ce déséquilibre croissant entre le nombre de retraités et de salariés, le gouvernement projette de relever l’âge de la retraite au-delà de 70 ans. Une bataille contre le déclin démographique dans laquelle devra bientôt s’engager l’Europe de l’Ouest.',
        },

        {
            title: 'France',
            content: 'Grand Paris Express, le chantier de tous les superlatifs. La France met en chantier le plus grand projet urbain de transports en commun d’Europe avec 200 km de nouvelles lignes automatiques (autant que le métro actuel) et 68 gares. La finalisation du projet est prévue pour 2030 et 35 milliards d’euros y seront consacrés.',
        },

    ]
};

